import { CommandSlot } from "src/games/ProgramRobotGame/objects/CommandSlot";
import { Command } from "src/games/ProgramRobotGame/objects/Command";

export class Arrow {
    public arrowId: number;
    public slot: CommandSlot;
    public command: Command;
    public object: Phaser.GameObjects.Image;

    constructor(arrowId: number, command: Command, object: Phaser.GameObjects.Image) {
        this.arrowId = arrowId;
        this.command = command;
        this.object = object;
        this.slot = null;
    }
}



// WEBPACK FOOTER //
// ./src/games/ProgramRobotGame/objects/Arrow.ts